function getSkelSize() {
    var skelBreakpoints = skel.vars.stateId,
        size = 'xxlarge';
    if (skelBreakpoints.search("/xsmall") > -1) {
        size = 'xsmall';
    } else if (skelBreakpoints.search("/small") > -1) {
        size = 'small';
    } else if (skelBreakpoints.search("/medium") > -1) {
        size = 'medium';
    } else if (skelBreakpoints.search("/large") > -1) {
        size = 'large';
    } else if (skelBreakpoints.search("/xlarge") > -1) {
        size = 'xlarge';
    }
    return size;
}

function getNumSkelSize() {
    var skelBreakpoints = skel.vars.stateId,
        size = 6;
    if (skelBreakpoints.search("/xsmall") > -1) {
        size = 1;
    } else if (skelBreakpoints.search("/small") > -1) {
        size = 2;
    } else if (skelBreakpoints.search("/medium") > -1) {
        size = 3;
    } else if (skelBreakpoints.search("/large") > -1) {
        size = 4;
    } else if (skelBreakpoints.search("/xlarge") > -1) {
        size = 5;
    }
    return size;
}

var messageBox = function($) {
    "use strict";

    function createWrapper(wrapperClass) {
        var elementClass = 'messages-wrapper';
        if ($("#messages-wrapper").length === 0) {
            if (wrapperClass.length > 0) {
                elementClass = elementClass + ' ' + wrapperClass;
            }
            $("body").append('' +
                '<div id="messages-wrapper" class="' + elementClass + '">' +
                '<div class="messages-container"></div>' +
                '</div>'
            );
        }
    } // END createMessageWrapper

    function createBox(wrapperClass) {
        if ($("#messages-wrapper").length === 0) {
            createWrapper(wrapperClass);
        }
        $("#messages-wrapper .messages-container").html('' +
            '<div id="message-box" class="message-box">' +
            '<span onclick="messageBox.destroy();" class="close" title="Zapri prijavno okno">&times;</span>' +
            '<div class="message-box-content"></div>' +
            '</div>'
        );
    } // END createBox

    function create(wrapperClass) {
        createWrapper(wrapperClass);
        createBox(wrapperClass);
    } // END create

    function destroy() {
        $("#messages-wrapper").remove();
    } // END destroyMessageWrapper



    function setContent(html) {
        $("#messages-wrapper .message-box-content").html(html);
        setBoxHeight();
    } // END setContent

    function setBoxHeight() {
        var windowHeight = getWindowHeight() * 0.9,
            outerHeight;
        $("#message-box").css('height', 'auto');
        outerHeight = $("#message-box").outerHeight();
        if (outerHeight > windowHeight) {
            $("#message-box").height(windowHeight);
            $("#message-box").css("overflow-y", "auto");
        } else {
            // $("#message-box").height(outerHeight);
            $("#message-box").css("overflow-y", "");
        }
    } // END setBoxHeight

    return {
        createWrapper: createWrapper,
        createBox: createBox,
        create: create,
        destroy: destroy,
        setContent: setContent,
        setBoxHeight: setBoxHeight
    }
}(jQuery); // END messageBox

var login = function($) {
    "use strict";

    function openForm() {
        $.ajax({
            async: true,
            type: "GET",
            url: "/content/arsluna.content.get.php",
            data: {
                "p_request": "login_form_get",
                "url": window.location.href,
                "p_timestamp": new Date().getTime()
            }
        }).done(function(result) {
            messageBox.create('login-form-wrapper');
            messageBox.setContent(result);
        }).fail(function(httpObj, textStatus) {
            return false;
        });
    } // END openForm

    function addParam(key, value) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        // kvp looks like ['key1=value1', 'key2=value2', ...]
        var kvp = document.location.search.substr(1).split('&');
        var i = 0;

        for (; i < kvp.length; i++) {
            if (kvp[i].startsWith(key + '=')) {
                var pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }

        if (i >= kvp.length) {
            kvp[kvp.length] = [key, value].join('=');
        }

        // can return this or...
        var params = kvp.join('&');

        // reload page with new params
        document.location.search = params;
    } // END insertParam

    function login() {
        var form = $("#form-login"),
            p_data;
        $("#form-login-errm").html("");
        $("#form-login-user-errm").html("");
        $("#form-login-pass-errm").html("");
        p_data = new Object();
        p_data.user = form.find('[name="user"]').val();
        p_data.pass = form.find('[name="pass"]').val();
        $.ajax({
            async: true,
            type: "POST",
            url: "/content/arsluna.content.post.php",
            data: {
                "p_request": "login",
                "p_data": JSON.stringify(p_data),
                "p_timestamp": new Date().getTime()
            }
        }).done(function(result) {
            if (result.success === 'ok') {
                if (result.data.unfinished_carts_count === 0) {
                    messageBox.destroy();
                    location.reload();
                } else {
                    messageBox.setContent(result.data.unfinished_carts);
                    messageBox.setBoxHeight();

                }
            } else {
                $("#form-login-errm").html(result.error);
                $("#form-login-user-errm").html(result.error_user);
                $("#form-login-pass-errm").html(result.error_pass);
            }
        }).fail(function(httpObj, textStatus) {
            $("#orm-login-errm").html(r.textStatus);
        });
    } // END login

    function logout() {
        var form = $("#form-login");
        $.ajax({
            async: true,
            type: "POST",
            url: "/content/arsluna.content.post.php",
            data: {
                "p_request": "logout",
                "p_timestamp": new Date().getTime()
            }
        }).done(function(result) {
            if (result.success === 'ok') {
                location.reload();
            } else {
                return false;
            }
        }).fail(function(httpObj, textStatus) {
            return false;
        });
    } // END logout

    return {
        openForm: openForm,
        login: login,
        logout: logout,
        addParam: addParam
    }

}(jQuery); // END login

var arslunaLeafletMap = function($) {
        "use strict";
        var config = {
            subdir: "/",
            icon_path: "/images/ico/",
            lat: 46.12028997201353,
            lon: 14.815506921582028,
            zoom: 8,
            scrollWheelZoom: false,
            mapProvider: "{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        };

        function init(map_obj, container, lat, lon, zoom) {
            lat = isNumber(lat) ? lat : config.lat;
            lon = isNumber(lon) ? lon : config.lon;
            zoom = isNumber(zoom) ? zoom : config.zoom;

            map_obj.map = L.map(
                container, {
                    scrollWheelZoom: config.scrollWheelZoom
                }
            ).setView(
                [lat, lon],
                zoom
            );

            L.tileLayer('https://' + config.mapProvider, {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map_obj.map);
            map_obj.marker = L.layerGroup().addTo(map_obj.map);

        } // END init

        function reset(map_obj) {
            setLocation(map_obj, config.lat, config.lon, config.zoom);
            map_obj.marker.clearLayers();
        } // END reset

        function setLocation(
            map_obj,
            lat,
            lon,
            zoom,
            marker,
            markerIcon,
            draggable
        ) {
            var newLatLang = [lat, lon];
            marker = marker === undefined ? false : marker;
            markerIcon = markerIcon !== undefined ? markerIcon : new L.Icon.Default();
            draggable = draggable !== undefined ? draggable : false;
            map_obj.map.setView(
                new L.LatLng(lat, lon),
                zoom
            );

            if (marker) {
                map_obj.markerPosition = L.marker(
                    [lat, lon], {
                        draggable: draggable,
                        icon: markerIcon
                    }
                ).addTo(map_obj.marker);
            }
        }

        function showAddressFromLatLng(map_obj, lat, lon) {
            var newLocation,
                popup,
                openStreetMapGeocoder = GeocoderJS.createGeocoder('openstreetmap');
            openStreetMapGeocoder.geodecode(lat, lon, function(result) {
                newLocation = result[0];
                newLocation.streetName = newLocation.streetName !== undefined ? newLocation.streetName : "";
                newLocation.streetNumber = newLocation.streetNumber !== undefined ? newLocation.streetNumber : "";
                newLocation.postal_code = newLocation.postal_code !== undefined ? newLocation.postal_code : "";
                newLocation.city = newLocation.city !== undefined ? newLocation.city : "";
                if (newLocation.city == "") {
                    newLocation.city = newLocation.town !== undefined ? newLocation.town : "";
                }
                if (newLocation.city == "") {
                    newLocation.city = newLocation.village !== undefined ? newLocation.village : "";
                }
                map_obj.markerPosition.bindPopup(newLocation.streetName + ' ' +
                    newLocation.streetNumber + '<br>' +
                    newLocation.postal_code + ' ' + newLocation.city
                ).openPopup();
                popup = L.popup()
                    .setLatLng([lat, lon])
                    .setContent('<p>' +
                        newLocation.streetName + ' ' +
                        newLocation.streetNumber + '<br>' +
                        newLocation.postal_code + ' ' + newLocation.city +
                        '</p>'
                    )
                    .openOn(map_obj.map);
            });

        } // END showAddressFromLatLng

        function getLocationFromAddress(address, post_code, post, country) {
            var query = address + ',' + post_code + ',' + post + ',' + country,
                openStreetMapGeocoder = GeocoderJS.createGeocoder('openstreetmap');
            openStreetMapGeocoder.geocode(query, function(result) {
                return result[0];
            });
        } // END getLocationFromAddress

        function setLocationFromAddress(
            map_obj,
            address,
            post_code,
            post,
            country,
            draggable
        ) {
            var query = address + ',' + post_code + ',' + post + ',' + country,
                openStreetMapGeocoder = GeocoderJS.createGeocoder('openstreetmap'),
                newLocation;
            openStreetMapGeocoder.geocode(query, function(result) {
                newLocation = result[0];
                setLocation(
                    map_obj,
                    newLocation.latitude,
                    newLocation.longitude,
                    17,
                    true,
                    undefined,
                    draggable
                );
            });
        } // END setLocationFromAddress

        function addPolyLine(map_obj, latlngs) {
            var polyline = L.polyline(latlngs, {
                color: 'red'
            }).addTo(map_obj.marker);
            // zoom the map to the polyline
            map_obj.map.fitBounds(polyline.getBounds());
        } // END addPolyLine

        return {
            config: config,
            init: init,
            reset: reset,
            setLocation: setLocation,
            setLocationFromAddress: setLocationFromAddress,
            addPolyLine: addPolyLine
        };
    }
    (jQuery); // END arslunaLeafletMap

var arslunaForm = function($) {
        "use strict";

        function validate(form) {
            var retval = new Object();
            retval.status = required(form);
            return retval;
        }

        function required(form) {
            var retval = 0;
            form.find('input[type="text"], input[type="number"], input[type="mail"], input[type="tel"], input[type="radio"], input:password, input:file, select, textarea').each(function() {
                if ($(this).attr("required") && $(this).val().length === 0) {
                    $(this).data("check_required", 1)
                    $(this).closest(".form-group").find(".input-msg-box").html("Vnosno polje je zahtevano").show();
                    retval = 1;
                } else {
                    $(this).data("check_required", 0)
                    $(this).closest(".form-group").find(".input-msg-box").html("").hide();
                }
            });

            if (retval == 1) {
                alertify
                    .reset()
                    .okBtn("V redu")
                    .alert("V vnesenih podatki so napake!");
            }

            return retval;
        }

        function clearMessages(form) {
            form.find(".form-group.required").each(function() {
                $(this).find(".input-msg-box").html("").hide();
            });
        }

        function roundStep(value, step) {
            return Math.round(value / step) * step;
        } // END roundStep

        function validateMinMaxStep(el) {
            var value = el.val(),
                retval = value,
                step = el.prop("step"),
                min = el.prop("min"),
                max = el.prop("max");
            if (isNumber(retval)) {
                if (isNumber(min)) {
                    retval = Math.max(retval, min);
                }
                if (isNumber(max)) {
                    retval = Math.min(retval, max);
                }
                if (isNumber(step)) {
                    retval = roundStep(retval, step);
                }
            } else {
                retval = '';
            }
            if (retval !== value) {
                el.val(retval);
            }
        } // END validateMinMaxStep

        return {
            validate: validate,
            validateMinMaxStep: validateMinMaxStep
        }
    }
    (jQuery); // END arslunaForm

jQuery(document).ready(function($) {
    $("body").on("change", '.check-min-max-step', function(event) {
        event.preventDefault();
        arslunaForm.validateMinMaxStep($(this));
    });

    $("body").on("click", '#form-login-button-login', function(event) {
        event.preventDefault();
        login.login();
    });
});
